import API from 'services/api';

import { ICompanySettings } from '../models/ICompanySettings';

export const getCompanySettings = (): Promise<ICompanySettings> =>
  API.get('/api/profile/company-settings').then(res => res?.data);
